import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index.js';
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import print from 'vue3-print-nb'

const app = createApp(App)
app.use(ElementPlus)

app.use(router)
app.mount('#app')
app.use(print)
